import { render, staticRenderFns } from "./ClientOrderDetails.vue?vue&type=template&id=8bf987fe&scoped=true"
import script from "./ClientOrderDetails.vue?vue&type=script&lang=js"
export * from "./ClientOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./ClientOrderDetails.vue?vue&type=style&index=0&id=8bf987fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf987fe",
  null
  
)

export default component.exports